const colors = {
  inherit: "inherit",
  current: "current",
  transparent: "transparent",
  black: "#000000",
  white: "#ffffff",
  gray: {
    50: "#F4F7F9",
    100: "#EBF0F4",
    200: "#DAE3EB",
    300: "#C3D1DE",
    400: "#AABACF",
    500: "#94A4C0",
    600: "#7D8BAE",
    700: "#747F9E",
    800: "#58627B",
    900: "#4B5264",
    950: "#2C303A",
  },
  red: {
    50: "#FEF2F2",
    100: "#FEE2E2",
    200: "#FECACA",
    300: "#FCA5A5",
    400: "#F97170",
    500: "#EF3837",
    600: "#DD2625",
    700: "#BA1C1B",
    800: "#9A1B1A",
    900: "#801D1C",
    950: "#450A0A",
  },
  orange: {
    50: "#FFF6EC",
    100: "#FFEBD3",
    200: "#FFD3A5",
    300: "#FFB46D",
    400: "#FF8932",
    500: "#FF670A",
    600: "#FF4D00",
    700: "#CC3502",
    800: "#A12A0B",
    900: "#82250C",
    950: "#460F04",
  },
  yellow: {
    50: "#FFFFEA",
    100: "#FFFBC5",
    200: "#FFF885",
    300: "#FFED46",
    400: "#FFDF1B",
    500: "#FFBF00",
    600: "#E29300",
    700: "#BB6802",
    800: "#985008",
    900: "#7C420B",
    950: "#482200",
  },
  green: {
    50: "#ECFDF5",
    100: "#D2F9E5",
    200: "#A9F1CF",
    300: "#72E3B5",
    400: "#37CE95",
    500: "#15B47D",
    600: "#099265",
    700: "#077555",
    800: "#095C44",
    900: "#084C39",
    950: "#032B20",
  },
  teal: {
    50: "#F3FAFA",
    100: "#D5F2F0",
    200: "#ABE4E1",
    300: "#79CFCD",
    400: "#4EB1B3",
    500: "#349598",
    600: "#2C8388",
    700: "#235E62",
    800: "#204B4F",
    900: "#1F3F42",
    950: "#0C2427",
  },
  cyan: {
    50: "#EAFEFF",
    100: "#CBFBFF",
    200: "#9EF5FF",
    300: "#5BEBFF",
    400: "#00D4FF",
    500: "#00BAE5",
    600: "#0093C0",
    700: "#03749B",
    800: "#0D5E7D",
    900: "#104E69",
    950: "#033249",
  },
  blue: {
    50: "#EFF6FF",
    100: "#DAEAFF",
    200: "#BEDBFF",
    300: "#91C6FF",
    400: "#5DA6FD",
    500: "#3882F9",
    600: "#2263EE",
    700: "#194BD3",
    800: "#1C40B1",
    900: "#1C3A8C",
    950: "#162455",
  },
  violet: {
    50: "#F4F2FF",
    100: "#EAE8FF",
    200: "#D8D4FF",
    300: "#BBB2FF",
    400: "#9580FF",
    500: "#7955FD",
    600: "#6932F5",
    700: "#5A20E1",
    800: "#4C1ABD",
    900: "#40189A",
    950: "#250C69",
  },
  pink: {
    50: "#FFF1F4",
    100: "#FFE3E8",
    200: "#FFCCD8",
    300: "#FFA1B8",
    400: "#FF7397",
    500: "#F93A70",
    600: "#E7175C",
    700: "#C30D4D",
    800: "#A30E48",
    900: "#8B1044",
    950: "#4E0320",
  },
};

export type Colors = typeof colors;

export const getColors = (): Colors => {
  return colors;
};
